import { Tooltip } from 'antd';

export type CallColor = 'red' | 'yellow' | 'blue' | 'green' | 'brown' | 'black' | 'no_activity';

/**
 * Operator-facing label + accent colour for each call-icon tag.
 * Order matches the call-flow lifecycle: untouched → missed → callback → drop-off → confirmed.
 */
export const CALL_FILTER_OPTIONS: Array<{
  value: CallColor;
  label: string; // Uzbek (Latin), per ops spec
  hex: string;
  bg: string; // light tinted background for the inactive pill
}> = [
  { value: 'no_activity', label: "Faollik yo'q",          hex: '#9CA3AF', bg: '#F3F4F6' },
  { value: 'red',         label: "Ko'tarmadi",            hex: '#EF4444', bg: '#FEF2F2' },
  { value: 'yellow',      label: 'Keyinroq aloqa',        hex: '#F59E0B', bg: '#FFFBEB' },
  { value: 'blue',        label: "Oxirigacha bitmagan",   hex: '#3B82F6', bg: '#EFF6FF' },
  { value: 'green',       label: 'Tasdiqlangan',          hex: '#10B981', bg: '#ECFDF5' },
  { value: 'brown',       label: 'Rasvo qilinganlar',     hex: '#92400E', bg: '#FEF3C7' },
  { value: 'black',       label: "Qora ro'yxat",          hex: '#1F2937', bg: '#F3F4F6' },
];

interface CallColorFiltersProps {
  /** Current selection — `null`/undefined = no filter. */
  value: CallColor | null | undefined;
  onChange: (next: CallColor | null) => void;
}

/**
 * Inline row of round colour-coded badges. Sits next to the page title.
 * Click a pill to filter the list to users with that tag, click again to
 * clear.
 */
export const CallColorFilters: React.FC<CallColorFiltersProps> = ({
  value,
  onChange,
}) => {
  return (
    <span style={{ display: 'inline-flex', gap: 6, marginLeft: 12, verticalAlign: 'middle' }}>
      {CALL_FILTER_OPTIONS.map((opt) => {
        const active = value === opt.value;
        return (
          <Tooltip key={opt.value} title={active ? 'Filterni olib tashlash' : `Filter: ${opt.label}`}>
            <button
              type="button"
              onClick={() => onChange(active ? null : opt.value)}
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 6,
                padding: '4px 10px',
                borderRadius: 999,
                fontSize: 12,
                fontWeight: 600,
                cursor: 'pointer',
                transition: 'all 0.15s',
                color: active ? '#fff' : opt.hex,
                background: active ? opt.hex : opt.bg,
                border: `1px solid ${active ? opt.hex : opt.hex + '33'}`,
                lineHeight: 1.2,
                whiteSpace: 'nowrap',
              }}
            >
              <span
                style={{
                  width: 8,
                  height: 8,
                  borderRadius: '50%',
                  background: active ? '#fff' : opt.hex,
                  display: 'inline-block',
                }}
              />
              {opt.label}
            </button>
          </Tooltip>
        );
      })}
    </span>
  );
};
